import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { cssVars } from './theme.js'

// Inject CSS custom properties
const style = document.createElement('style')
style.textContent = cssVars
document.head.appendChild(style)

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
